export class Translation {
    public create: any = {};
    public record: any = {};
    public check: any = {};
    public download: any = {};
    public PDF: any = {};
    public case: any = {};
    public track: any = {};
}